import { normalize } from 'normalizr';

import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import {
  SiteGroupWeatherConfiguration,
  siteGroupWeatherConfigurationSchema,
} from '@sophocles/entities/SiteGroupWeatherConfiguration/siteGroupWeatherConfigurationRecord';
import { addToast } from '@sophocles/features/toast';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

/* Receive Actions */
export const RECEIVE_SITE_GROUP_WEATHER_CONFIGURATIONS = 'RECEIVE_SITE_GROUP_WEATHER_CONFIGURATIONS';
export function receiveSiteGroupWeatherConfigurations(json) {
  return {
    type: RECEIVE_SITE_GROUP_WEATHER_CONFIGURATIONS,
    siteGroupWeatherConfigurations: mapListToRecords(json, SiteGroupWeatherConfiguration),
  };
}

/* Request Actions */
// starter request
export const REQUEST_SITE_GROUP_WEATHER_CONFIGURATION = 'REQUEST_SITE_GROUP_WEATHER_CONFIGURATION';
function requestSiteGroupWeatherConfiguration(siteGroupWeatherConfiguration_id) {
  return {
    type: REQUEST_SITE_GROUP_WEATHER_CONFIGURATION,
    siteGroupWeatherConfiguration_id,
  };
}

export const REQUEST_SITE_GROUP_WEATHER_CONFIGURATION_FOR_SITE_GROUP =
  'REQUEST_SITE_GROUP_WEATHER_CONFIGURATION_FOR_SITE_GROUP';
function requestSiteGroupWeatherConfigurationForSiteGroup(siteGroup_id) {
  return {
    type: REQUEST_SITE_GROUP_WEATHER_CONFIGURATION_FOR_SITE_GROUP,
    siteGroup_id,
  };
}

export const REQUEST_SITE_WEATHER = 'REQUEST_SITE_WEATHER';
function requestSiteWeather(siteGroup_id) {
  return {
    type: REQUEST_SITE_WEATHER,
    siteGroup_id,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchSiteGroupWeatherConfiguration(siteGroupWeatherConfiguration_id) {
  return dispatch => {
    dispatch(requestSiteGroupWeatherConfiguration(siteGroupWeatherConfiguration_id));
    return apiClient
      .get(`/sitegroupweatherconfigurations/${siteGroupWeatherConfiguration_id}/`)
      .then(checkHttpStatus)
      .then(response =>
        normalizeList(response.data, 'siteGroupWeatherConfigurations', siteGroupWeatherConfigurationSchema),
      )
      .then(json => dispatch(receiveSiteGroupWeatherConfigurations(json.entities.siteGroupWeatherConfigurations)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_SITE_GROUP_WEATHER_CONFIGURATION)));
  };
}

export function fetchSiteGroupWeatherConfigurationForSiteGroup(siteGroup_id) {
  return dispatch => {
    dispatch(requestSiteGroupWeatherConfigurationForSiteGroup(siteGroup_id));
    return apiClient
      .get(`/sitegroupweatherconfigurations/?site_group=${siteGroup_id}`)
      .then(checkHttpStatus)
      .then(response =>
        normalizeList(response.data.results, 'siteGroupWeatherConfigurations', siteGroupWeatherConfigurationSchema),
      )
      .then(json => dispatch(receiveSiteGroupWeatherConfigurations(json.entities.siteGroupWeatherConfigurations)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_SITE_GROUP_WEATHER_CONFIGURATION_FOR_SITE_GROUP)));
  };
}

/* Edit Actions */
export const EDIT_SITE_GROUP_WEATHER_CONFIGURATION = 'EDIT_SITE_GROUP_WEATHER_CONFIGURATION';
export function editSiteGroupWeatherConfiguration(siteGroupWeatherConfiguration_id) {
  return {
    type: EDIT_SITE_GROUP_WEATHER_CONFIGURATION,
    siteGroupWeatherConfiguration: siteGroupWeatherConfiguration_id,
  };
}

export function patchSiteGroupWeatherConfiguration(siteGroupWeatherConfiguration_id, values) {
  return dispatch => {
    dispatch(editSiteGroupWeatherConfiguration(siteGroupWeatherConfiguration_id));
    return apiClient
      .patch(`/sitegroupweatherconfigurations/${siteGroupWeatherConfiguration_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, siteGroupWeatherConfigurationSchema))
      .then(json => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Smart-Weather settings updated',
            level: 'success',
            dismissible: true,
          }),
        );
        return dispatch(receiveSiteGroupWeatherConfigurations(json.entities.siteGroupWeatherConfigurations));
      })
      .catch(error => dispatch(genericErrorAction(error, EDIT_SITE_GROUP_WEATHER_CONFIGURATION)));
  };
}

export function sendSiteGroupWeatherAction(siteGroupWeatherConfiguration_id, values) {
  return dispatch => {
    dispatch(editSiteGroupWeatherConfiguration(siteGroupWeatherConfiguration_id));
    return apiClient
      .post(`/sitegroups/${siteGroupWeatherConfiguration_id}/toggle_weather_enabled/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, siteGroupWeatherConfigurationSchema))
      .then(json => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Smart-Weather settings updated',
            level: 'success',
            dismissible: true,
          }),
        );
        return dispatch(receiveSiteGroupWeatherConfigurations(json.entities.siteGroupWeatherConfigurations));
      })
      .catch(error => dispatch(genericErrorAction(error, EDIT_SITE_GROUP_WEATHER_CONFIGURATION)));
  };
}

/* Create Actions */
export const CREATE_SITE_GROUP_WEATHER_CONFIGURATION = 'CREATE_SITE_GROUP_WEATHER_CONFIGURATION';
function sayCreateSiteGroupWeatherConfiguration(values) {
  return {
    type: CREATE_SITE_GROUP_WEATHER_CONFIGURATION,
    values: values,
  };
}

export function createSiteGroupWeatherConfiguration(values) {
  return dispatch => {
    dispatch(sayCreateSiteGroupWeatherConfiguration(values));
    return apiClient
      .post(`/sitegroupweatherconfigurations/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, siteGroupWeatherConfigurationSchema))
      .then(json => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Smart-Weather settings updated',
            level: 'success',
            dismissible: true,
          }),
        );
        return dispatch(receiveSiteGroupWeatherConfigurations(json.entities.siteGroupWeatherConfigurations));
      })
      .catch(error => dispatch(genericErrorAction(error, CREATE_SITE_GROUP_WEATHER_CONFIGURATION)));
  };
}

/* Delete Actions */
export const DELETE_SITE_GROUP_WEATHER_CONFIGURATION = 'DELETE_SITE_GROUP_WEATHER_CONFIGURATION';
function sayDeleteSiteGroupWeatherConfiguration(siteGroupWeatherConfiguration_id) {
  return {
    type: DELETE_SITE_GROUP_WEATHER_CONFIGURATION,
    siteGroupWeatherConfiguration: siteGroupWeatherConfiguration_id,
  };
}

export function deleteSiteGroupWeatherConfiguration(siteGroupWeatherConfiguration_id) {
  return dispatch =>
    apiClient
      .delete(`/sitegroupweatherconfigurations/${siteGroupWeatherConfiguration_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteSiteGroupWeatherConfiguration(siteGroupWeatherConfiguration_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_SITE_GROUP_WEATHER_CONFIGURATION)));
}
